<template>
  <div>
    <!-- User Header Card -->
    <v-card outlined class="mb-3">
      <v-card-title class="">
        {{ userData.user.displayName }}
      </v-card-title>
      <v-card-text>
        <performance-target-personal-result-view
          :total-status="normalizedTotalStatus"
          :traffic-light-status="normalizedTrafficLightStatus"
        ></performance-target-personal-result-view>
      </v-card-text>

      <v-card-text
        v-if="lastCalculatedAtFormatted && showLastCalculatedAt"
        class="pt-0 pb-3 grey--text text-caption"
      >
        <strong>Letzte Aktualisierung:</strong>
        {{ lastCalculatedAtFormatted }} Uhr
      </v-card-text>
    </v-card>

    <!-- Performance Target Results Grid -->
    <v-row dense>
      <v-col
        cols="12"
        md="6"
        sm="12"
        v-for="(result, index) in performanceTargetResultsArray"
        :key="index"
      >
        <!-- Result Summary Card -->
        <performance-target-result-card
          :result="result"
          :show-details="true"
          :use-default-style="false"
        ></performance-target-result-card>

        <!-- Calculation Details Card -->
        <performance-target-result-calculation-card
          :result="result"
          class="mb-3"
        ></performance-target-result-calculation-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PerformanceTargetPersonalResultView from "@/components/member-management/performance-targets/PerformanceTargetPersonalResultView.vue";
import PerformanceTargetResultCard from "@/components/member-management/performance-targets/PerformanceTargetResultCard.vue";
import PerformanceTargetResultCalculationCard from "@/components/member-management/performance-targets/PerformanceTargetResultCalculationCard.vue";

export default {
  name: "performance-target-results-details-content",
  components: {
    PerformanceTargetPersonalResultView,
    PerformanceTargetResultCard,
    PerformanceTargetResultCalculationCard,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
    showLastCalculatedAt: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // Normalized totalStatus - handles both property names from different parent components
    normalizedTotalStatus() {
      // SelfServicePerformanceMonitoring uses 'totalStatus'
      // PerformanceTargetsTabOverview uses 'totalPerformanceTargetResultStatus'
      return (
        this.userData?.totalStatus ||
        this.userData?.totalPerformanceTargetResultStatus ||
        "unknown"
      );
    },
    // Normalized trafficLightStatus
    normalizedTrafficLightStatus() {
      return this.userData?.trafficLightStatus || "unknown";
    },
    lastCalculatedAtFormatted() {
      const timestamp = this.userData?.lastCalculatedAt;
      console.log(timestamp);
      if (!timestamp) {
        return null;
      }
      // Handle Firestore Timestamp or Date object
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
      return date.toLocaleString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    performanceTargetResultsArray() {
      if (!this.userData) {
        return [];
      }

      // Try performanceTargets first (from SelfServicePerformanceMonitoring)
      if (this.userData.performanceTargets) {
        // Check if it's an object (needs conversion to array)
        if (
          typeof this.userData.performanceTargets === "object" &&
          !Array.isArray(this.userData.performanceTargets)
        ) {
          // Convert object to array
          const array = Object.values(this.userData.performanceTargets);
          console.log("Converted performanceTargets object to array:", array);
          return array;
        }
        // Already an array
        return this.userData.performanceTargets;
      }

      // Try performanceTargetResults (from PerformanceTargetsResultsDataTable)
      if (this.userData.performanceTargetResults) {
        // Check if it's an object (needs conversion to array)
        if (
          typeof this.userData.performanceTargetResults === "object" &&
          !Array.isArray(this.userData.performanceTargetResults)
        ) {
          // Convert object to array
          const array = Object.values(this.userData.performanceTargetResults);
          console.log(
            "Converted performanceTargetResults object to array:",
            array
          );
          return array;
        }
        // Already an array
        return this.userData.performanceTargetResults;
      }

      return [];
    },
  },
};
</script>
